import React from 'react';
import { Phone } from 'lucide-react';
import './Hero.css';

const Hero = () => {
  const handleBookAppointment = () => {
    window.open('https://clinicia.com/calendar/book?u=75835', '_blank');
  };

  const handleCallNow = () => {
    window.location.href = 'tel:+919959975995';
  };

  return (
    <section id="hero" className="hero-section">
      <div className="hero-background">
        <div className="hero-curve"></div>
      </div>
      
      <div className="container">
        <div className="hero-grid">
          <div className="hero-content fade-in">
            <h1 className="hero-large">Your Smile, Our Priority.</h1>
            <p className="body-large hero-subtitle">
              Premium family-friendly dental care designed for comfort and confidence.
            </p>
            <div className="hero-buttons">
              <button className="btn-primary" onClick={handleBookAppointment}>
                Book Appointment
              </button>
              <button className="btn-secondary" onClick={handleCallNow}>
                <Phone size={18} />
                Call Now
              </button>
            </div>
          </div>
          
          <div className="hero-image-container fade-in">
            <div className="hero-image-wrapper gold-shimmer">
              <img 
                src="https://images.unsplash.com/photo-1629909613638-0e4a1fad8f81?crop=entropy&cs=srgb&fm=jpg&q=85" 
                alt="Modern Dental Clinic" 
                className="hero-image"
              />
              <div className="hero-image-accent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;